/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  DatePicker,
  Tabs,
} from 'antd';
import {
  InfoCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { getMeses } from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import moment from 'moment';
import { getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
import TabPane from 'antd/lib/tabs/TabPane';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import CustomSearch from 'components/customSearch';
import { getPlaza } from 'api/catalogos/plazas';
import { getJornadaDetalle } from 'api/catalogos/JornadaDetalle';
import JustificacionGeneralReloj from './JustificacionGeneral';
import JustificacionJustificarReloj from './JustificacionForms';
import ModalExportarReporte from './ModalExportarReporte';
import JustificacionGrupal from './JustificacionGrupal';

export const justificacionRelojPermission = {
  permissionModel: 'justificacionrelojchecador',
  catalogsModels: [],
  tabsModels: [],
};

const JustificacionReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [topLevelTabKey, setTopLevelTabKey] = useState('individual');
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [_selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  const [openSearch, setVisibleSearch] = useState(false);
  const [plazas, setPlazas] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [dataSearch, setDataSearch] = useState([]);
  const [puestosPorEmpleado, setPuestosPorEmpleado] = useState({});
  const [parentData, setParentData] = useState([]);
  const [dataToSearch, setDataToSearch] = useState([]);
  const [autorizar_rechazar, setAutorizar_rechazar] = useState(false);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [meses, setMeses] = useState([]);

  let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const findPuesto = async (empleados) => {
    const nuevosPuestos = {};
    await Promise.all(
      empleados.map(async (emp) => {
        try {
          const plazaEmp = await getPlaza(emp.plaza);
          nuevosPuestos[emp.id] = plazaEmp?.puesto_descripcion || '';
        } catch {
          nuevosPuestos[emp.id] = '';
        }
      }),
    );

    setPuestosPorEmpleado(nuevosPuestos);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURIDatosOpPaginado);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
    await findPuesto(_empleados.results);
    setDataSearch(_empleados);
    return setLoading(false);
  };

  const validateInput = async () => {
    setLoading(true);
    setSelectedEmpleadoSearch();
    const searchEmp = form.getFieldValue('empleado');
    if (!searchEmp) {
      setVisibleSearch(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(
      `${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`,
    );

    const result = res?.results?.[0];

    const plazaEmp = result ? await getPlaza(result.plaza) : null;
    const jornadaEmp = plazaEmp ? await getJornadaDetalle(result.jornada_detalle) : null;

    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    if (empleadoResult) {
      form.setFieldsValue({
        empleado_number: empleadoResult?.id,
        empleado_identified: empleadoResult?.numero_y_nombre_completo,
        area: plazaEmp?.directorio_de_area_clave_y_nombre,
        plaza: `${plazaEmp?.categoria} - ${plazaEmp?.categoria_nombre}`,
        puesto: plazaEmp?.puesto_clave_y_descripcion,
        jornada: plazaEmp?.jornada_detalle_descripcion_rango_horario,
        tipo_de_checado: plazaEmp?.tipo_de_checado_nombre,
        con_vigencia: jornadaEmp?.aplica_vigencia ? 'Sí' : 'No',
        vigencia_inicial: jornadaEmp?.aplica_vigencia
          ? jornadaEmp?.fecha_inicial : '',
        vigencia_final: jornadaEmp?.aplica_vigencia
          ? jornadaEmp?.fecha_final : '',
      });
      setPlazas(plazaEmp);
    } else {
      form.resetFields(['empleado']);
    }
    // onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };

  const defineDateValues = (value, valueTime = 'month') => {
    if (!value || !moment.isMoment(value)) {
      form.setFieldValue('fecha_inicial', '');
      form.setFieldValue('fecha_final', '');
      return;
    }
    const firstDay = value.clone().startOf(valueTime);
    const lastDay = value.clone().endOf(valueTime);

    form.setFieldValue('fecha_inicial', firstDay);
    form.setFieldValue('fecha_final', lastDay);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tipos_de_nominas_empleados,
        _periodosFiscales,
        _meses,
      ] = await Promise.all([
        getTiposDeNominasEmpleados(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getMeses(),
      ]);
      if (mounted) {
        const defaultYear = _periodosFiscales[_periodosFiscales.length - 1];
        const defaultDate = moment().year(defaultYear?.descripcion);
        form.setFieldValue('periodo_fiscal', defaultYear?.id);
        form.setFieldValue('mes', defaultDate.month() + 1);

        defineDateValues(defaultDate);

        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setPeriodosFiscales(_periodosFiscales);
        setMeses(_meses);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const changeToForms = (_dataId, _autorizar_rechazar) => {
    const _parentData = {
      _dataId,
      ...plazas,
    };
    setParentData(_parentData);
    setAutorizar_rechazar(_autorizar_rechazar);
    setCurrentParentTabKey('justificacion');
  };

  const handleParentTabChange = (key) => {
    if (key === 'reporte') {
      setExportModalVisible(true);
    } else {
      setCurrentParentTabKey(key);
    }
  };

  const criterioBusqueda = () => {
    const _empleado = form.getFieldValue('empleado_number');
    const _mes = form.getFieldValue('mes');
    const _periodo_fiscal = form.getFieldValue('periodo_fiscal');
    return ({
      ...(_empleado && { empleado_id: _empleado }),
      ...(_mes && { mes_id: _mes }),
      ...(_periodo_fiscal && { periodo_fiscal_id: _periodo_fiscal }),
    });
  };

  const onClickBuscar = async () => {
    await form.validateFields();
    setLoading(true);

    setDataToSearch(criterioBusqueda());
    setLoading(false);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (_, empObject) => puestosPorEmpleado[empObject.id],
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Tabs
        type="card"
        activeKey={topLevelTabKey}
        onChange={setTopLevelTabKey}
      >
        <TabPane tab="Individual" key="individual" forceRender>
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              scrollToFirstError
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Row align="middle">
                    <Col xs={24} sm={24} md={24}>
                      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Form.Item
                          label="No. y Nombre del Empleado"
                          name="empleado"
                          hasFeedback
                        >
                          <Input
                            allowClear
                          />
                        </Form.Item>
                        <Button
                          loading={loading}
                          onClick={validateInput}
                          icon={<SearchOutlined />}
                          style={{
                            width: '2.7rem',
                            height: '2rem',
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="periodo_fiscal"
                    label="Año"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosFiscales}
                      onChange={(value) => {
                        const año = periodosFiscales.find((item) => item.id === value);
                        const date = moment().year(año?.descripcion);
                        defineDateValues(date);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="mes"
                    label="Mes"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      labelProp="nombre"
                      keyProp="id"
                      dataSource={meses}
                      onChange={(value) => {
                        let date = moment().month(value - 1);
                        let timeValue = 'month';
                        if (!value) {
                          const year = form.getFieldValue('periodo_fiscal');
                          const año = periodosFiscales.find((item) => item.id === year);
                          date = moment().year(año?.descripcion);
                          timeValue = 'year';
                        }
                        defineDateValues(date, timeValue);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="empleado_identified"
                    label="Empleado"
                    rules={rules.required}
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="fecha_inicial"
                    label="Fecha Inicial"
                  >
                    <DatePicker
                      allowClear
                      disabled
                      format="DD-MM-YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="fecha_final"
                    label="Fecha Final"
                  >
                    <DatePicker
                      allowClear
                      disabled
                      format="DD-MM-YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="area"
                    label="Área"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="plaza"
                    label="Plaza"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="puesto"
                    label="Puesto"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="tipo_de_checado"
                    label="Tipo de Checado"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="jornada"
                    label="Jornada"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="con_vigencia"
                    label="Con Vigencia"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="vigencia_inicial"
                    label="Vigencia Inicial"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="vigencia_final"
                    label="Vigencia Final"
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item>
                    <Button
                      onClick={() => onClickBuscar()}
                    >
                      Consultar
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Tabs
              type="card"
              activeKey={currentParentTabKey || 'general'} // Evitar undefined
              onChange={handleParentTabChange}
            >
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    {' '}
                    General
                  </span>
            )}
                key="general"
                forceRender
              >
                <JustificacionGeneralReloj
                  permission={permission}
                  changeToForms={changeToForms}
                  data_to_search={dataToSearch}
                />
              </TabPane>
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    {' '}
                    Justificación
                  </span>
            )}
                key="justificacion"
                disabled
              >
                <JustificacionJustificarReloj
                  datos_padre={parentData}
                  autorizar_rechazar={autorizar_rechazar}
                  updateTable={onClickBuscar}
                />
              </TabPane>
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    {' '}
                    Generar Reporte
                  </span>
            )}
                key="reporte"
              />
            </Tabs>
            <CustomSearch
              form={form}
              open={openSearch}
              setVisible={setVisibleSearch}
              modalTitle="Buscar Empleado"
              firstInputLabel="No. de Empleado"
              firstInputName="numero_de_empleado"
              secondInputLabel="Nombre del Empleado"
              secondInputName="nombre"
              searchInputLabel="Apellido Paterno"
              searchInputName="apellido_paterno"
              thirdInputLabel="Apellido Materno"
              thirdInputName="apellido_materno"
              firstSelectLabel="Tipo de Nómina Empleado"
              firstSelectName="tipo_de_nomina_empleado"
              firstSelectDataSource={tiposDeNominaEmpleado}
              inputsNeeded={3}
              selectsNeeded={1}
              paginatedTable
              modalWidth={1400}
              columns={columnsEmpleado}
              baseURI={baseURIPagination}
              setSelectedRow={setSelectedEmpleadoSearch}
              onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
              data={dataSearch}
              setData={setDataSearch}
              searchData={searchData}
              onChange={(row) => {
                setSelectedEmpleadoSearch(row);
              }}
            />
            <ModalExportarReporte
              visible={exportModalVisible}
              onCancel={() => setExportModalVisible(false)}
              parentForm={form}
              periodosFiscales={periodosFiscales}
              meses={meses}
            />
          </Spin>
        </TabPane>
        <TabPane tab="Justificación Grupal" key="grupal" forceRender>
          <JustificacionGrupal permission={permission} />
        </TabPane>
      </Tabs>
    </Row>
  );
};

export default JustificacionReloj;
